The identifier for the `Candidate`.

This is unique for a given hirer & person.
